var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2706 13.5601L10.3906 15.4401",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2706 15.4401L10.3906 13.5601",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10573 8.74659C8.03906 8.73992 7.95906 8.73992 7.88573 8.74659C6.29906 8.69325 5.03906 7.39325 5.03906 5.79325C5.03906 4.15992 6.35906 2.83325 7.99906 2.83325C9.6324 2.83325 10.9591 4.15992 10.9591 5.79325C10.9524 7.39325 9.6924 8.69325 8.10573 8.74659Z",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00313 16.04C6.78979 16.04 5.58313 15.7333 4.66313 15.12C3.04979 14.04 3.04979 12.28 4.66313 11.2066C6.49646 9.97995 9.50313 9.97995 11.3365 11.2066",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivate);
export default __webpack_public_path__ + "static/media/deactivate.91f31b534fc5ae91af9ec243730e4fd6.svg";
export { ForwardRef as ReactComponent };